import { alias, createModelSchema, custom, deserialize, list, serialize, SKIP } from "serializr";
import { BaseObject } from "@/common/BaseObject";
import { LevelTrackLevelPattern } from "./LevelTrackLevelPattern";

export class LevelTrackLevelField extends BaseObject {
    constructor() {
        super();

        this._tiles = [[""]];
        this._pattern = [];
    }

    get tiles() {
        return this._tiles;
    }

    set tiles(value) {
        this._tiles = value;
    }

    get pattern() {
        return this._pattern;
    }

    set pattern(value) {
        this._pattern = value;
    }

    valid() {
        if (
            !Array.isArray(this.tiles) ||
            this.tiles.some(row => !Array.isArray(row) || row.some(tile => typeof tile !== "string" || tile.trim().length === 0)) ||
            this.tiles.length === 0 ||
            (this.tiles.length !== 0 && this.tiles[0].length === 0)
            // (this.tiles.length !== 0 && this.tiles.some(t => t.length !== this.tiles.length))
        ) {
            return false;
        }

        if (!Array.isArray(this.pattern) || this.pattern.some(p => !p.valid())) {
            return false;
        }

        return super.valid();
    }

    empty() {
        return (
            (!this.tiles || this.tiles.length === 0) &&
            (!this.pattern || this.pattern.length === 0) &&
            super.empty()
        );
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new LevelTrackLevelField());
        } else if (target instanceof LevelTrackLevelField) {
            return super.clone(target);
        } else {
            return undefined;
        }
    }

    static schema() {
        return custom(
            (v) => (v && !v.empty() ? serialize(LevelTrackLevelField, v) : SKIP),
            (v) => deserialize(LevelTrackLevelField, v)
        );
    }
}

createModelSchema(LevelTrackLevelField, {
    _tiles: alias("tiles", list(list(toString()))),
    _pattern: alias("pattern", list(LevelTrackLevelPattern.schema())),
});

function toString() {
    return custom(
        (value) => String(value),
        (value) => String(value),
    );
}
